"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropType = void 0;
/**
 * Prop Type
 */
var PropType;
(function (PropType) {
    PropType["Automobile"] = "Automobile";
    PropType["Trailer"] = "Trailer";
    PropType["Motorcycle"] = "Motorcycle";
    PropType["Skates"] = "Skates";
    PropType["Skateboard"] = "Skateboard";
    PropType["Bicycle"] = "Bicycle";
    PropType["Moped"] = "Moped";
    PropType["Camera"] = "Camera";
    PropType["Pet"] = "Pet";
    PropType["Footwear"] = "Footwear";
    PropType["Luggage"] = "Luggage";
    PropType["GolfClubs"] = "Golf Clubs";
    PropType["GolfBag"] = "GolfBag";
    PropType["TennisRacquet"] = "Tennis Racquet";
    PropType["Skis"] = "Skis";
    PropType["Binoculars"] = "Binoculars";
    PropType["OperaGlasses"] = "Opera Glasses";
    PropType["LargePortableRadio"] = "Large Portable Radio";
    PropType["Book"] = "Book";
    PropType["Laptop"] = "Laptop";
    PropType["CellPhone"] = "CellPhone";
    PropType["Tablet"] = "Tablet";
    PropType["PDA"] = "PDA";
    PropType["MP3Player"] = "MP3 Player";
    PropType["Other"] = "Other";
})(PropType || (exports.PropType = PropType = {}));
//# sourceMappingURL=prop-types.js.map